export function dateToString(timeStampDate: Date): string {
  const hours = timeStampDate.getHours();
  const ampm = hours >= 12 ? 'p.m.' : 'a.m.';
  const adjustedHours = hours % 12 || 12;
  const timeStamp = `${String(adjustedHours)}:${String(timeStampDate.getMinutes()).padStart(2, '0')} ${ampm}`;
  return timeStamp;
}

export function formatArrivalDate(dateString?: string): string {
  if (!dateString) return '';
  const date = new Date(dateString);
  const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  return `${days[date.getDay()]}, ${months[date.getMonth()]} ${date.getDate()}`;
}
